import { useContext } from 'react';

import { appEntryParamsContext } from '@modules/core/contexts/appEntryParams';
import { IAppEntryContext } from '@modules/core/contexts/appEntryParams/interfaces';

const useAppEntryParams = () => useContext<IAppEntryContext>(appEntryParamsContext);

export default useAppEntryParams;
